import { render, staticRenderFns } from "./oulandFactoryInfo.vue?vue&type=template&id=858ff42e&scoped=true"
import script from "./oulandFactoryInfo.vue?vue&type=script&lang=js"
export * from "./oulandFactoryInfo.vue?vue&type=script&lang=js"
import style0 from "./oulandFactoryInfo.vue?vue&type=style&index=0&id=858ff42e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858ff42e",
  null
  
)

export default component.exports